import { File } from '../generated/graphql';

export function isCreativeAbleToSendToFacebook(creative: { file: Pick<File, 'size' | 'mimeType'> }): boolean {
  if (creative.file.mimeType.startsWith('video/')) {
    const SIZE_LIMIT = 524288000; // 500MB
    return creative.file.size < SIZE_LIMIT;
  }
  return false;
}

export function isCreativeAbleToSendToGoogle(creative: { file: Pick<File, 'mimeType'> }): boolean {
  if (creative.file.mimeType.startsWith('video/')) {
    return true;
  }
  return false;
}

export function isCreativeAbleToSendToAmazon(creative: { file: Pick<File, 'mimeType'> }): boolean {
  if (creative.file.mimeType.startsWith('video/')) {
    return true;
  }
  return false;
}

export function isCreativeAbleToSendToYahoo(creative: { file: Pick<File, 'mimeType'> }): boolean {
  if (creative.file.mimeType.startsWith('video/')) {
    return true;
  }
  return false;
}

export function isCreativeAbleToSendToTiktok(creative: { file: Pick<File, 'mimeType'> }): boolean {
  if (creative.file.mimeType.startsWith('video/')) {
    return true;
  }
  return false;
}
